import { render, staticRenderFns } from "./ApprovalInquiry.vue?vue&type=template&id=59b78530&scoped=true"
import script from "./ApprovalInquiry.vue?vue&type=script&lang=js"
export * from "./ApprovalInquiry.vue?vue&type=script&lang=js"
import style0 from "./ApprovalInquiry.vue?vue&type=style&index=0&id=59b78530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b78530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VDataTable,VDatePicker,VMenu,VPagination,VRow,VTextField})
